import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, { useState } from "react";

const headers = [
  {
    key: "product_name",
    parent: "product",
    name: "Product Name",
  },
  {
    key: "unit_name",
    parent: "unit",
    name: "Unit Name",
  },
  {
    key: "retail_price",
    name: "Retail Price",
  },
  {
    key: "wholesale_price",
    name: "Wholesale Price",
  },
  {
    key: "currency",
    name: "Currency",
  },
];

const detailPopupHeaders = [
  {
    key: "product_id",
    name: "Product ID",
  },
  {
    key: "product_name",
    name: "Product Name",
  },
  {
    key: "prefix_code",
    name: "Prefix Code",
  },
  {
    key: "barcode",
    name: "Barcode",
  },
  {
    key: "product_category_name",
    parent: "productCategory",
    name: "Product Category",
  },
  {
    key: "currency",
    parent: "productPrice",
    name: "Currency",
  },
  {
    key: "retail_price",
    parent: "productPrice",
    name: "Retail Price",
  },
  {
    key: "wholesale_price",
    parent: "productPrice",
    name: "Wholesale Price",
  },
  // {
  //     key: '',
  //     name: 'SKU',//????
  // },
  {
    key: "price_date",
    parent: "productPrice",
    name: "Price Date",
  },
  {
    key: "remark",
    name: "Remark",
  },
];


export default function ProductPriceChangeList() {
  const [searchValue, setSearchValue] = useState(""); 
  const location   = useLocation();
  const currentPath = location.pathname;

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/product-price-change/list",
    defaultQuery: "status=ACTIVE",
  });

  const handleSearch = (value) => {
    const trimmed = value.trim();
    if(trimmed.length > 0){
      setSearchValue(trimmed);
      setQuery({
        search: trimmed,
      });
    }else{
      setQuery({});
    }
  };


  const nothingFoundAfterSearch =
  searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Product Price Change List"
      data={data}
      headers={headers}
      setCurrentPage={setCurrentPage}
      idKey="price_id"
      endPoint="/product-price-change"
      hasSearch
      module="Product"
      subModule="Product Price Change List"
      hasCreate
      createPath={`/product/price-change/create`}
      hasActions
      removeDetails={true}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      reload={reload}
      setQuery={setQuery}
      searchValue={searchValue}                      
      nothingFoundAfterSearch={nothingFoundAfterSearch}
    />
);

}
